<template>
    <section id="about" class="company-intro">
        <div class="container">
            <div class="intro-grid">
                <!-- 文本内容 -->
                <div class="intro-content">
                    <h2 class="section-title">COMPANY PROFILE</h2>
                   <p class="section-subtitle">公司简介</p>
                    <div class="intro-text">
                        <p>深圳国华未来智慧科技有限公司是一家专注于人工智能（AI）技术研发与应用的创新型企业，致力于为全球客户提供前沿的AI解决方案和智能化产品。公司以技术创新为核心，深耕计算机视觉、自然语言处理、机器学习等领域，赋能各行各业实现数字化、智能化升级。
                            我们汇聚了一支由顶尖AI科学家、工程师和行业专家组成的团队，凭借自主研发的核心算法和先进的技术架构，成功打造了多款高效、安全、可落地的AI产品。国华未来智慧科技始终秉持“科技改变未来”的理念，以客户需求为导向，持续推动AI技术的边界，助力企业降本增效，提升竞争力。未来，我们将继续与合作伙伴携手，探索人工智能的无限可能，共创智能新时代
                        </p>
                    </div>

                    <!-- <div class="achievements">
                        <div class="achievement-item" v-for="(item, index) in achievements" :key="index">
                            <div class="achievement-value">{{ item.value }}</div>
                            <div class="achievement-label">{{ item.label }}</div>
                        </div>
                    </div> -->

                    <!-- <router-link to="/about" class="learn-more-btn">
                        了解更多
                        <svg viewBox="0 0 24 24">
                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                        </svg>
                    </router-link> -->
                </div>

                <!-- 图片 -->
                <div class="intro-image">
                    <div class="image-wrapper">
                        <img src="@/assets/images/company-image.jpg" alt="公司团队工作场景" loading="lazy" class="main-image">
                        <div class="image-overlay"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
// import { ref } from 'vue'
// const achievements = ref([
//     { value: "8+", label: "年行业经验" },
//     { value: "500+", label: "企业客户" },
//     { value: "50+", label: "技术专利" },
//     { value: "100%", label: "客户满意度" }
// ])
</script>

<style scoped>
.company-intro {
    /* padding: 80px 0; */
    background-color: white;
    position: relative;
    overflow: hidden;
    background-color: #F6F6FF;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.intro-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    align-items: center;
}

.intro-content {
    position: relative;
    z-index: 2;
}

.section-title {
    font-size: 1.5rem;
    color: var(--dark);
    margin-bottom: 15px;
    font-weight: 700;
}

.section-subtitle {
    font-size: 1.2rem;
    color: var(--primary);
    margin-bottom: 30px;
    font-weight: 500;
}

.intro-text {
    margin-bottom: 40px;
}

.intro-text p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: var(--gray);
    margin-bottom: 20px;
}

.achievements {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 20px;
    margin-bottom: 40px;
}

.achievement-item {
    text-align: center;
    padding: 20px 15px;
    background-color: rgba(67, 97, 238, 0.05);
    border-radius: var(--border-radius);
    transition: var(--transition);
}

.achievement-item:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow);
}

.achievement-value {
    font-size: 2rem;
    font-weight: 700;
    color: var(--primary);
    margin-bottom: 5px;
}

.achievement-label {
    font-size: 0.9rem;
    color: var(--gray);
}

.learn-more-btn {
    display: inline-flex;
    align-items: center;
    padding: 12px 30px;
    background-color: var(--primary);
    color: white;
    text-decoration: none;
    border-radius: var(--border-radius);
    font-weight: 600;
    transition: var(--transition);
}

.learn-more-btn:hover {
    background-color: var(--secondary);
    transform: translateY(-2px);
    box-shadow: var(--shadow-hover);
}

.learn-more-btn svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
    margin-left: 8px;
}

.intro-image {
    position: relative;
}

.image-wrapper {
    position: relative;
    border-radius: var(--border-radius);
    overflow: hidden;
    box-shadow: var(--shadow);
    height: 400px;
}

.main-image {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.5s ease;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg,
            rgba(67, 97, 238, 0.3) 0%,
            rgba(67, 97, 238, 0.1) 100%);
    z-index: 1;
}

.image-wrapper:hover .main-image {
    transform: scale(1.05);
}

/* 响应式设计 */
@media (max-width: 992px) {
    .intro-grid {
        grid-template-columns: 1fr;
        gap: 40px;
    }

    .intro-content {
        order: 2;
        text-align: center;
    }

    .intro-image {
        order: 1;
        max-width: 600px;
        margin: 0 auto;
    }

    .achievements {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }
}

@media (max-width: 576px) {
    .company-intro {
        padding: 60px 0;
    }

    .section-title {
        font-size: 2rem;
    }

    .achievements {
        grid-template-columns: 1fr 1fr;
    }

    .learn-more-btn {
        width: 100%;
        justify-content: center;
    }
}
</style>